import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import StepConnector, {
	stepConnectorClasses,
} from "@mui/material/StepConnector";
import {
	SaveOutlined,
	SpeakerNotesOutlined,
	VisibilityOutlined,
} from "@mui/icons-material";

//Linha
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
	[`&.${stepConnectorClasses.alternativeLabel}`]: {
		top: 22,
	},
	[`&.${stepConnectorClasses.active}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			backgroundImage: theme.palette.gradient.buttonSelected,
		},
	},
	[`&.${stepConnectorClasses.completed}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			backgroundImage: theme.palette.gradient.buttonSelected,
		},
	},
	[`& .${stepConnectorClasses.line}`]: {
		height: 3,
		border: 0,
		backgroundColor: theme.palette.grey[300],
		borderRadius: 1,
		...theme.applyStyles("dark", {
			backgroundColor: theme.palette.grey[800],
		}),
	},
}));

//Box ICON
const ColorlibStepIconRoot = styled("div")(({ theme }) => ({
	backgroundColor: theme.palette.grey[400],
	zIndex: 1,
	color: theme.palette.white.main,
	width: 35,
	height: 35,
	display: "flex",
	borderRadius: "50%",
	justifyContent: "center",
	alignItems: "center",
	...theme.applyStyles("dark", {
		backgroundColor: theme.palette.grey[700],
	}),
	variants: [
		{
			props: ({ ownerState }) => ownerState.active,
			style: {
				backgroundImage: theme.palette.gradient.buttonSelected,
				boxShadow: `0 4px 10px 0 ${theme.palette.black.darker}40`,
			},
		},
		{
			props: ({ ownerState }) => ownerState.completed,
			style: {
				backgroundImage: theme.palette.gradient.buttonSelected,
			},
		},
	],
}));

function ColorlibStepIcon(props) {
	const { active, completed, className } = props;

	const icons = {
		1: <SpeakerNotesOutlined sx={{ fontSize: "20px" }} />,
		2: <VisibilityOutlined sx={{ fontSize: "20px" }} />,
		3: <SaveOutlined sx={{ fontSize: "20px" }} />,
	};

	return (
		<ColorlibStepIconRoot
			ownerState={{ completed, active }}
			className={className}
		>
			{icons[String(props.icon)]}
		</ColorlibStepIconRoot>
	);
}

ColorlibStepIcon.propTypes = {
	/**
	 * Whether this step is active.
	 * @default false
	 */
	active: PropTypes.bool,
	className: PropTypes.string,
	/**
	 * Mark the step as completed. Is passed to child components.
	 * @default false
	 */
	completed: PropTypes.bool,
	/**
	 * The label displayed in the step icon.
	 */
	icon: PropTypes.node,
};

export default function CustomizedSteppers(params) {
	const {
		steps = ["Novo formulário", "Pré-visualização", "Salvar"],
		stepNumber = 0,
	} = params;
	return (
		<Stack sx={{ width: "100%", marginTop: "-15px" }} spacing={4}>
			<Stepper
				alternativeLabel
				activeStep={stepNumber}
				connector={<ColorlibConnector />}
			>
				{steps.map((label) => (
					<Step key={label}>
						<StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
					</Step>
				))}
			</Stepper>
		</Stack>
	);
}
